<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">IAN FLEMING’S INSPIRATION</h1>
<p class="sub-title">THE TRUTH BEHIND THE BOOKS</p>
<p class="author">EDWARD ABEL SMITH</p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?e8f78e9a